import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetCategoriesAction, CreateCategoriesAction } from "../actions/CategoryActions";

interface Category {
    _id: string;
    name: string;
}

interface CategoryState {
    categories: Category[];
    loading: boolean;
    error: string | null;
    addCategoryDataLoading: boolean;
}

const initialState: CategoryState = {
    categories: [],
    loading: false,
    error: null,
    addCategoryDataLoading: false
};

const categorySlice = createSlice({
    name: "categories",
    initialState,
    reducers: {
        addCategory: (state, action: PayloadAction<Category>) => {
            if (!state.categories.some((c) => c.name === action.payload.name)) {
                state.categories.push(action.payload);
            }
        },
        setCategories: (state, action: PayloadAction<Category[]>) => {
            state.categories = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetCategoriesAction.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.categories = [];
            })
            .addCase(GetCategoriesAction.fulfilled, (state, action) => {
                state.loading = false;
                state.categories = action.payload?.data || [];
            })
            .addCase(GetCategoriesAction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to fetch categories";
            })

            .addCase(CreateCategoriesAction.pending, (state) => {
                state.addCategoryDataLoading = true;
            })
            .addCase(CreateCategoriesAction.fulfilled, (state, action) => {
                state.addCategoryDataLoading = false;
            })
            .addCase(CreateCategoriesAction.rejected, (state, action) => {
                state.addCategoryDataLoading = false;
            })


    },
});

export const { addCategory, setCategories } = categorySlice.actions;
export default categorySlice.reducer;
